import React, { Component } from 'react';
import { number, bool, string, func, object, shape } from 'prop-types';
import { translateSurveyStatus } from '../../lib/formatters';
import SurveyLocationSelect from '../../Surveys/SurveyLocationSelect';
import SurveyProfileAnalyzed from '../../Surveys/SurveyProfileAnalyzed';
import EmployeeCompanyDataItem from '../../Surveys/EmployeeCompanyDataItem';
import CommonErrorBoundary from '../../Util/CommonErrorBoundary';
import Input from '../../Input/Input';

export default class CardFooter extends Component {
  static propTypes = {
    typeOfMatch: string.isRequired,
    surveyCode: string,
    isPayscaleMatch: bool,
    surveyStatus: bool,
    showIncludeExclude: bool,
    surveyRow: object,
    jobDetails: object,
    matchId: number,
    orgJobId: number,
    jobSurveyActions: func,
    saveProfilesAnalyzed: func,
    companyData: shape({
      total_companies: number,
      total_incumbents: number
    }),
    readOnlyCard: bool,
    isSuggestedSurvey: bool
  };

  constructor(props) {
    super(props);
  }

  render() {
    const {
      app,
      surveyRow,
      jobSurveyActions,
      jobDetails,
      surveyStatus,
      showIncludeExclude,
      matchId,
      orgJobId,
      saveProfilesAnalyzed,
      isPayscaleMatch,
      surveyCode,
      companyData,
      typeOfMatch,
      readOnlyCard,
      isSuggestedSurvey
    } = this.props;

    let inclusionClass = '';
    let translatedSurveyStatus = translateSurveyStatus(surveyStatus);
    const matchIncluded = translatedSurveyStatus === 'Included';
    if (!matchIncluded) {
      inclusionClass = 'excluded';
    }

    let showStatus = '';
    if (!showIncludeExclude) {
      showStatus = 'hidden';
    }

    const excludeCard = {
      proposedAdj: 1,
      proposedGeo: 1,
      proposedWgt: 0,
      match_id: matchId
    };

    const includeCard = {
      proposedAdj: 1,
      proposedGeo: 1,
      proposedWgt: 1,
      match_id: matchId
    };

    let psCancelClass = 'current-match-card__footer--default';
    if (isPayscaleMatch) {
      psCancelClass = 'current-match-card__footer--ps-match';
    }

    return (
      <CommonErrorBoundary>
        <div className="current-match-card__footer">
          {isPayscaleMatch && app.basicProductName !== 'MarketPay' ? (
            <div className={`current-match-card__location ${inclusionClass}`}>
              <SurveyLocationSelect
                row={surveyRow}
                actions={jobSurveyActions}
                jobId={jobDetails.details.org_job_id}
                dropdownOnJobMatchCard={true}
                disabled={!matchIncluded}
              />
            </div>
          ) : (
            <div className={`current-match-card__survey-code ${inclusionClass}`}>{surveyCode}</div>
          )}
          {typeOfMatch === 'surveyMatch' && !readOnlyCard ? (
            <div className={`current-match-card__status ${showStatus}`}>
              <span className="current-match-card__status--label">Status: </span>
              {translateSurveyStatus(surveyStatus) === 'Included' ? (
                <span
                  className="current-match-card__status-text"
                  onClick={jobSurveyActions('updateMatch', 'get function').bind(this, excludeCard, orgJobId)}
                >
                  Included
                </span>
              ) : (
                <span
                  className="current-match-card__status-text excluded"
                  onClick={jobSurveyActions('updateMatch', 'get function').bind(this, includeCard, orgJobId)}
                >
                  Excluded
                </span>
              )}
            </div>
          ) : null}
          {typeOfMatch === 'surveyMatch' && !readOnlyCard && !isSuggestedSurvey ? (
            <div className="current-match-card__adj-fields--container">
              {['Adj', 'Geo', 'Wgt'].map(name => {
                const inputValue =
                  surveyRow['proposed' + name] !== undefined
                    ? surveyRow['proposed' + name]
                    : surveyRow[name.toLowerCase()];
                let input = (
                  <div className="current-match-card__adj-fields" key={'input-col-field-' + name}>
                    <span className="current-match-card__adj-fields--name">{name}:</span>
                    <Input
                      key={'input-col-field-' + name}
                      type="number"
                      min="0"
                      className="form-control  current-match-card__input-fields"
                      value={inputValue}
                      onChange={jobSurveyActions('adjInputChange', 'get function').bind(this, name, surveyRow)}
                      hideSpinBox={true}
                    />
                  </div>
                );

                let values = (
                  <div key={'input-col-field-' + name} className="current-match-card__adj-fields">
                    <span className="current-match-card__adj-fields--name">{name}:</span>
                    <span className="current-match-card__adj-fields--value">{surveyRow[name.toLowerCase()]}</span>
                  </div>
                );

                if (isPayscaleMatch && name !== 'Wgt') {
                  values = input = (
                    <div className="current-match-card__adj-fields" key={'input-col-field-' + name}>
                      <span className="current-match-card__adj-fields--name">{name}:</span>
                      <span className="current-match-card__adj-fields--value">Auto</span>
                    </div>
                  );
                }

                return surveyRow.surveyEditMode ? input : values;
              })}
            </div>
          ) : null}
          {typeOfMatch === 'surveyMatch' && !readOnlyCard && surveyRow.surveyEditMode ? (
            <div className={`current-match-card--cancel-save ${psCancelClass}`}>
              <button
                className="current-match-card__cancel"
                onClick={jobSurveyActions('clearEditState', 'get function').bind(this, surveyRow)}
              >
                Cancel
              </button>
              <button
                className="btn btn-primary current-match-card__save"
                onClick={jobSurveyActions('updateMatch', 'get function').bind(this, surveyRow, orgJobId)}
              >
                Save
              </button>
            </div>
          ) : (
            <div />
          )}
          {isPayscaleMatch ? (
            <div className={`current-match-card__profiles-analyzed ${inclusionClass}`}>
              <span className="profilesAnalyzed--popover">
                <SurveyProfileAnalyzed
                  surveyRow={surveyRow}
                  jobDetails={jobDetails}
                  saveProfilesAnalyzed={saveProfilesAnalyzed}
                  dropdownOnJobMatchCard={true}
                  disabled={!matchIncluded}
                />
              </span>
            </div>
          ) : (
            <div className={`current-match-card__employee-data ${inclusionClass}`}>
              <EmployeeCompanyDataItem companyData={companyData} isPayscaleRow={false} companyDataInDropdown={false} />
            </div>
          )}
        </div>
      </CommonErrorBoundary>
    );
  }
}
